export const EventStatus = [
  { id: 'published', name: 'Нийтлэсэн' },
  { id: 'drafted', name: 'Драфтласан' },
  { id: 'in_review', name: 'Хянагдах' },
  { id: 'completed', name: 'Дууссан' },
];
